module.exports = __webpack_public_path__ + "2912748981bb4cc122235405a5df9d9b.png";